import React from "react";
import { Link } from "react-router-dom";
import mockAccesories from "./mockAccesories";
import "./Accesories.scss";

const Accesories = () => {
  return (
    <div className="Accesories">
      {mockAccesories.map((product) => (
        <div className="Accesories-container">
          <div
            className="Accesories-container_card"
          >
            <img className="Accesories-container_card--img" src={product.img}></img>
            <h2 className="Accesories-container_card--txt">{product.model}</h2>
          </div>
        </div>
      ))}
      <h3 className="Accesories-info">¡Bienvenido a nuestra página de accesorios! Queremos informarte que nuestra página está diseñada principalmente para proporcionarte información sobre los accesorios que ofrecemos. Sin embargo, si no encuentras un producto específico en la lista, ¡no te preocupes! Contamos con una amplia variedad de productos que podrían no estar listados aquí. Te invitamos a ponerte en contacto con nosotros para consultar sobre cualquier artículo que desees. Estamos seguros de que podremos ayudarte a encontrar lo que necesitas. ¡Esperamos tener noticias tuyas pronto!</h3>
    </div>
  );
};

export default Accesories;